<!--
  - Copyright (c) 2022.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div>
        <van-nav-bar
            :title="tester.id?'修改受检人':'添加受检人'"
            left-arrow
            @click-left="$router.go(-1)"
        />

        <van-notice-bar text="请准确填写信息，信息错误将无法正常检查。" />
        <van-form label-width="100" style="background: white;">
            <van-field
                v-model="tester.name"
                placeholder="请输入姓名"
            >
                <template #label>
                    <span style="color: red;">* </span><span>姓名</span>
                </template>
            </van-field>
            <van-field
                readonly
                clickable
                name="picker"
                :value="tester.certTypeName"
                placeholder="点击选择证件类型"
                @click="showCertTypeClicked"
            >
                <template #label>
                    <span style="color: red;">* </span><span>证件类型</span>
                </template>
            </van-field>
            <van-popup v-model="showCertTypePicker" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="certTypes"
                    :default-index="certTypeIndex"
                    @confirm="certTypeSelected"
                    @cancel="showCertTypePicker = false"
                />
            </van-popup>
            <van-field
                v-model="tester.certNo"
                placeholder="请输入证件号码"
            >
                <template #label>
                    <span style="color: red;">* </span><span>证件号码</span>
                </template>
            </van-field>
            <van-field name="radio" :disabled="tester.certType === '1'">
                <template #input>
                    <van-radio-group :disabled="tester.certType === '1'" v-model="tester.sex" direction="horizontal">
                        <van-radio :name="'1'" checked-color="var(--color)">男</van-radio>
                        <van-radio :name="'2'" checked-color="var(--color)">女</van-radio>
                    </van-radio-group>
                </template>
                <template #label>
                    <span style="color: red;">* </span><span>性别</span>
                </template>
            </van-field>
            <van-field
                readonly
                clickable
                :value="formatBirthday(tester.birthday)"
                :disabled="tester.certType === '1'"
                placeholder="点击选择生日"
                @click="birthdayClicked"
            >
                <template #label>
                    <span style="color: red;">* </span><span>生日</span>
                </template>
            </van-field>
            <van-popup v-model="showBirthdayPicker" position="bottom">
                <van-datetime-picker
                    v-model="tester.birthday"
                    type="date"
                    title="选择生日"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="birthdaySelected"
                    @cancel="showBirthdayPicker=false"
                />
            </van-popup>
            <van-field
                v-model="tester.mobile"
                placeholder="请输入手机号"
            >
                <template #label>
                    <span style="color: red;">* </span><span>手机号</span>
                </template>
            </van-field>

            <van-field name="radio">
                <template #input>
                    <van-checkbox checked-color="var(--color)" v-model="authAddress">授权{{ companyNameShort }}代为接收本人体检报告并快递</van-checkbox>
                </template>
            </van-field>

            <van-field
                v-model="tester.address"
                rows="2"
                :disabled="!authAddress"
                autosize
                type="textarea"
                maxlength="100"
                label="快递地址"
                placeholder="请输入体检报告寄送地址"
            >
            </van-field>

            <van-field name="radio" label="是否晕血/晕针">
                <template #input>
                    <van-radio-group v-model="tester.bloodPhobia" direction="horizontal">
                        <van-radio :name="true" checked-color="var(--color)">是</van-radio>
                        <van-radio :name="false" checked-color="var(--color)">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field
                v-model="tester.diseaseHistory"
                label="病史"
                type="textarea"
                rows="2"
                maxlength="500"
                placeholder="可输入病史（选填）"
            />
            <van-field
                v-model="tester.familyHistory"
                label="家族史"
                type="textarea"
                rows="2"
                maxlength="500"
                placeholder="可输入家族史（选填）"
            />
            <van-field
                v-model="tester.medicineHistory"
                label="服药史"
                type="textarea"
                rows="2"
                maxlength="500"
                placeholder="可输入服药史（选填）"
            />

            <div style="padding: 16px;">
                <van-checkbox v-model="tester.defaultTester" checked-color="var(--color)" style="background: white; ">
                    设为默认受检人
                </van-checkbox>
                <div style="font-size: 12px; margin: 10px 0;">
                    <p style="text-indent:26px;">为了给您提供线上预约服务，我们需要收集您填写的包括敏感个人信息在内的个人信息。如您不同意提供该等敏感个人信息，我们将无法向您提供线上预约服务。如您同意我们收集您的个人信息， 请您填写：姓名、 性别、生日、证件类型、身份证号。</p>
                    <p style="text-indent:26px;">您行使与个人信息有关的权利、我们对您个人信息的保护措施等其他事项，您可通过我们的<span @click="$router.push('/info?icid=58&id=0&rc=0')" style="color: var(--color);">《个人信息保护政策》</span>知晓。我们将尽力保护您提供给我们的个人信息的安全性。您知晓，客观上无法保证白分之百 的安全，一旦您的敏感个人信息因不可抗力而被泄露或者非法使用，可能导致您的人格尊严受到侵害或者人身、财产安全受到危害。</p>
                </div>
                <van-button :loading="loading" round block color="var(--color)" @click="saveTesterClicked">{{ tester.id?'保存':'添加' }}</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import qs from "qs";
import http from "@/utils/http";
import moment from "moment";
import {Notify} from "vant";
import {COMPANY_NAME_SHORT} from "@/utils/http";

export default {
    name: "MyTesterEdit",
    data() {
        return {
            companyNameShort: COMPANY_NAME_SHORT,
            loading: false,
            tester: {id: 0, sex:'', certType:'1', certTypeName:'身份证', bloodPhobia: false},
            showCertTypePicker: false,
            certTypeIndex:2,
            showBirthdayPicker: false,
            authAddress: true,
            minDate: moment().subtract(100, 'years').toDate(),
            maxDate: new Date(),
            certTypes: []
        };
    },
    components: {
    },
    mounted() {
        var id = this.$route.query.id?this.$route.query.id:'';
        if(!id) {
            id = '0';
        }
        this.tester.id = parseInt(id);
        this.loadCertTypes();
        if(this.tester.id) {
            this.loadDetail()
        }
    },
    watch: {
        "tester.certNo": function (value) {
            if (this.tester.certType === '1') {
                var validIdCard = this.validIdCard(value);
                if (validIdCard.isTrue) {
                    this.tester.sex = validIdCard.isMale ? '1' : '2';
                    this.tester.birthday = moment([
                        validIdCard.year,
                        validIdCard.month - 1,
                        validIdCard.day,
                    ]).toDate();
                    this.$forceUpdate();
                }
            }
            // console.log(this.validIdCard(value))
        },
    },
    methods: {
        loadDetail: function() {
            http.get('/api/personal/load_tester?id='+this.tester.id).then(res => {
                // console.log(res)
                if (!res.data.result) {
                    Notify({type: 'danger', message: res.data.message});
                } else {
                    this.tester = res.data.extra.tester;
                    // console.log(this.tester)
                }
            });
        },
        loadCertTypes() {
            http.get('/api/public/dict?code=cert-type').then(res => {
                this.certTypes = res.data.map(item => {
                    return {text:item.label,value:item.value}
                });
                // console.log(this.certTypes)
            });
        },
        showCertTypeClicked() {
            var idx = this.tester.certType?this.certTypes.map(item => item.value).indexOf(this.tester.certType):0;
            if(idx < 0) {
                idx = 0;
            }
            this.certTypeIndex = idx;
            // console.log(this.certTypes)
            this.showCertTypePicker = true
        },
        certTypeSelected(selected) {
            this.tester.certType = selected.value;
            this.tester.certTypeName = selected.text;
            this.showCertTypePicker = false;
        },
        birthdayClicked() {
            if(this.tester.certType === '1') {//身份证就不需要选择生日
                return;
            }
            if(!this.tester.birthday) {
                this.tester.birthday = moment().subtract(30, 'years').toDate();
            }
            this.showBirthdayPicker = true;
        },
        birthdaySelected(date) {
            this.showBirthdayPicker = false;
            this.tester.birthday = date;
        },
        formatBirthday(date) {
            if(!date) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD");
        },
        validIdCard(cardNo) {
            var info = {
                isTrue: false,
                year: null,
                month: null,
                day: null,
                isMale: false,
                isFemale: false,
            };
            if (!cardNo || (15 != cardNo.length && 18 != cardNo.length)) {
                info.isTrue = false;
                return info;
            }
            if (15 == cardNo.length) {
                var year = cardNo.substring(6, 8);
                var month = cardNo.substring(8, 10);
                var day = cardNo.substring(10, 12);
                var p = cardNo.substring(14, 15); //性别位
                var birthday = new Date(year, parseFloat(month) - 1, parseFloat(day));
                // 对于老身份证中的年龄则不需考虑千年虫问题而使用getYear()方法
                if (
                    birthday.getYear() != parseFloat(year) ||
                    birthday.getMonth() != parseFloat(month) - 1 ||
                    birthday.getDate() != parseFloat(day)
                ) {
                    info.isTrue = false;
                } else {
                    info.isTrue = true;
                    info.year = birthday.getFullYear();
                    info.month = birthday.getMonth() + 1;
                    info.day = birthday.getDate();
                    if (p % 2 == 0) {
                        info.isFemale = true;
                        info.isMale = false;
                    } else {
                        info.isFemale = false;
                        info.isMale = true;
                    }
                }
                return info;
            }
            if (18 == cardNo.length) {
                var year = cardNo.substring(6, 10);
                var month = cardNo.substring(10, 12);
                var day = cardNo.substring(12, 14);
                var p = cardNo.substring(14, 17);
                var birthday = new Date(year, parseFloat(month) - 1, parseFloat(day));
                // 这里用getFullYear()获取年份，避免千年虫问题
                if (
                    birthday.getFullYear() != parseFloat(year) ||
                    birthday.getMonth() != parseFloat(month) - 1 ||
                    birthday.getDate() != parseFloat(day)
                ) {
                    info.isTrue = false;
                    return info;
                }
                var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子
                var Y = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 身份证验证位值.10代表X
                // 验证校验位
                var sum = 0; // 声明加权求和变量
                var _cardNo = cardNo.split("");

                if (_cardNo[17].toLowerCase() == "x") {
                    _cardNo[17] = 10; // 将最后位为x的验证码替换为10方便后续操作
                }
                for (var i = 0; i < 17; i++) {
                    sum += Wi[i] * _cardNo[i]; // 加权求和
                }
                var i = sum % 11; // 得到验证码所位置

                if (_cardNo[17] != Y[i]) {
                    info.isTrue = false;
                    return info;
                }
                info.isTrue = true;
                info.year = birthday.getFullYear();
                info.month = birthday.getMonth() + 1;
                info.day = birthday.getDate();
                if (p % 2 == 0) {
                    info.isFemale = true;
                    info.isMale = false;
                } else {
                    info.isFemale = false;
                    info.isMale = true;
                }
                return info;
            }
            return info;
        },
        saveTesterClicked() {
            if(this.tester.certType === '1') {
                var validIdCard = this.validIdCard(this.tester.certNo);
                if (validIdCard.isTrue) {
                    this.tester.sex = validIdCard.isMale ? '1' : '2';
                    this.tester.birthday = moment([
                        validIdCard.year,
                        validIdCard.month - 1,
                        validIdCard.day,
                    ]).toDate();
                } else {
                    Notify({type: 'danger', message: '请输入正确的身份证号码'});
                    return;
                }
            }
            this.loading = true;
            var tester = JSON.parse(JSON.stringify(this.tester));
            tester.birthday = this.formatBirthday(tester.birthday);
            if(!this.authAddress) {
                tester.address = '';
            }
            http.post('/api/personal/save_tester', qs.stringify(tester)).then(res => {
                this.loading = false;
                if (!res.data.result) {
                    Notify({type: 'danger', message: res.data.message});
                } else {
                    Notify({type: 'success', message: res.data.message});
                    this.$router.go(-1);
                }
            }).catch(()=>this.loading = false);
        }
    },
}
</script>

<style scoped>

</style>